export function pluralize(n: number, singular: string, plural: string) {
  return n === 1 ? singular : plural
}

export function capitalizeFirstLetter(s: string) {
  return s.charAt(0).toUpperCase() + s.slice(1)
}

export function formatArray(array: string[], lastSeparator: string = 'and') {
  if (array.length <= 1) {
    const onlyElement = array[0]
    return onlyElement
  } else {
    const allButLast = array.slice(0, -1)
    const last = array.slice(-1)
    return `${allButLast.join(', ')} ${lastSeparator} ${last}`
  }
}

const REVERSE_REGEX = /-[a-z\u00E0-\u00F6\u00F8-\u00FE]/g

export function kebabCase(str: string) {
  return str
    .replace(/([a-z])([A-Z])/g, '$1-$2')
    .replace(/[\s_]+/g, '-')
    .toLowerCase()
}

export function reverse(str: string) {
  return str.replace(REVERSE_REGEX, function (match: string) {
    return match.slice(1).toUpperCase()
  })
}
